<template>
  <div class="view-failure-records">
    <div class="records-list" ref="recordsList">
      <div 
        v-for="(item, index) in recordsArray" 
        :key="index" 
        class="record-item"
      >
        <div class="record-row">
          <span class="record-label">操作人：</span>
          <span class="record-value">{{ placeholderText(item.operatorName) }}</span>
        </div>
        <div class="record-row">
          <span class="record-label">操作时间：</span>
          <span class="record-value">{{ formatOperationTime(item.operationTime) }}</span>
        </div>
        <div class="record-row content-row">
          <span class="record-label">操作内容：</span>
          <span class="record-value">{{ placeholderText(item.operationContent) }}</span>
        </div>
      </div>
      <div v-if="recordsArray.length === 0" class="records-empty">
        暂无处理记录
      </div>
    </div>
  </div>
</template>

<script>
import { DateTool } from "@js/date-tool.js";

export default {
  name: "ViewFailureRecords",

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    }
  },

  data: function () {
    return {
      recordsArray: [],
    };
  },

  async mounted() {
    this.recordsListRequest();
  },

  methods: {
    // 数据格式化方法
    placeholderText(rawValue) {
      if (!rawValue || rawValue === "null") {
        return "-";
      }
      return rawValue;
    },

    formatOperationTime(operationTime) {
      return this.placeholderText(
        DateTool.formatDate(
          DateTool.strToDate(operationTime),
          "Y-M-D h:m:s"
        )
      );
    },

    // 接口请求方法
    async recordsListRequest() {
      try {
        const params = {
          targetId: this.deviceData.maintenanceOrderId,
          pageNum: 1,
          pageSize: 100,
          targetType: "maintenance_order",
        };
        
        // 调用getSleepOperationLogs接口获取处理记录
        const response = await this.$api.getSleepOperationLogs(params);
        this.recordsArray = response.list || [];
      } catch (error) {
        console.error('获取处理记录失败:', error);
        this.$toast.showRed("获取处理记录失败");
        // 错误时显示空数据
        this.recordsArray = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.view-failure-records {
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  .records-list {
    height: 100%;
    overflow-y: scroll;
    background-color: white;
    border: rem(1) solid #e8e8e8;
    border-radius: rem(4);
    
    .record-item {
      padding: rem(16) rem(20);
      border-bottom: rem(1) solid #f0f0f0;
      transition: background-color 0.2s;
      
      &:hover {
        background-color: #fafafa;
      }
      
      &:last-child {
        border-bottom: none;
      }
      
      .record-row {
        display: flex;
        margin-bottom: rem(8);
        font-size: rem(14);
        line-height: rem(20);
        
        &:last-child {
          margin-bottom: 0;
        }
        
        &.content-row {
          align-items: flex-start;
          
          .record-value {
            word-break: break-all;
            white-space: normal;
          }
        }
        
        .record-label {
          color: rgba(0, 0, 0, 0.65);
          font-weight: normal;
          width: rem(80);
          flex-shrink: 0;
          text-align: right;
          margin-right: rem(12);
        }
        
        .record-value {
          color: rgba(0, 0, 0, 0.85);
          flex: 1;
        }
      }
    }
    
    .records-empty {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999999;
      font-size: rem(14);
      min-height: rem(200);
    }
  }
}
</style>
